import { useState } from "react";

import { useNavigate } from "react-router-dom";

import { useDispatch } from "react-redux";

import { httpsCallable } from "firebase/functions";

import { getIdTokenResult, GoogleAuthProvider, signInWithCustomToken, signInWithPopup } from "firebase/auth";

import { setUser } from "../../store/slices/authSlice";

import { AppUser } from "../../types/User";

import { auth, functions } from "../../config/firebaseConfig";

import { trackEvent } from "../../util/analytics";

const login = httpsCallable(functions, "loginUser");

export default function LoginPage() {

    const [email, setEmail] = useState("");

    const [password, setPassword] = useState("");

    const [error, setError] = useState("");

    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    const dispatch = useDispatch();

    // ✅ Email validation

    const isValidEmail = (email: string) =>

        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    // ✅ Password minimum length

    const isPasswordValid = password.length >= 8;

    // ✅ Enable Sign In button

    const canSubmit = isValidEmail(email) && isPasswordValid && !loading;

    const provider = new GoogleAuthProvider();

    async function loginWithGoogle() {
        try {
            setLoading(true);   // ✅ START LOADING
    
            const result = await signInWithPopup(auth, provider);
    
            const idToken = await result.user.getIdToken();
    
            const googleLogin = httpsCallable(functions, "googleLoginUser");
    
            const resp: any = await googleLogin({ idToken });
    
            const { customToken, uid, email, role, basicInfoSetup, emailVerified } =
                resp.data;
    
            await signInWithCustomToken(auth, customToken);
    
            const user: AppUser = {
                uid,
                email,
                displayName: result.user.displayName,
                dob: null,
                emailVerified,
                basicInfoSetup,
                role,
            };
    
            dispatch(setUser(user));
    
            if (!basicInfoSetup && role === "user") navigate("/setup-profile");
            else navigate("/");
    
        } catch (error) {
            console.error("Google login error:", error);
        } finally {
            setLoading(false);  // ✅ STOP LOADING
        }
    }

    async function handleLogin(e: React.FormEvent) {

        e.preventDefault();

        setError("");

        setLoading(true);

        try {

            const result: any = await login({ email, password });

            const {

                customToken,

                uid,

                email: userEmail,

                role,

                basicInfoSetup,

                emailVerified,

                dob,

            } = result.data || {};

            if (!customToken) {

                throw new Error("Missing customToken from server response.");

            }

            await signInWithCustomToken(auth, customToken);

            const tokenResult = await getIdTokenResult(auth.currentUser!, true);

            const user: AppUser = {

                uid,

                email: userEmail,

                displayName: null,

                dob: dob || null,

                emailVerified: !!emailVerified,

                basicInfoSetup: !!basicInfoSetup,

                role,

            };

            dispatch(setUser(user));

            console.log("logic", !basicInfoSetup && role === 'user')

            trackEvent("sign_in_success", {

                screen: "login",

            });

            console.log("sdsad")

            if (!basicInfoSetup && role === 'user') navigate("/setup-profile");

            navigate("/");

        } catch (err: any) {

            console.error("❌ Login failed:", err?.code || "", err?.message || err);

            if (err.message?.includes("not registered") || err.code === "not-found") {

                setError("E-mail not registered.");

            } else if (err.code === "invalid-email") {

                setError("Invalid email address.");

            } else if (err.code === "auth/invalid-custom-token") {

                setError("Invalid credentials. Please try again.");

            } else if (err?.message === "Email not verified") {

                navigate(`/auth/await-email?email=${encodeURIComponent(email)}`);

            } else {

                setError(err?.message || "Login failed, please try again.");

            }

        } finally {

            setLoading(false);

        }

    }

    return (

        <>

            <h1 className="text-dark-text text-[20px] font-medium">

                Sign in to your account

            </h1>

            {/* <button onClick={loginWithGoogle} className=" flex gap-3 justify-center items-center bg-dark-background w-full border-dark-border border-2 rounded-xl  mt-4 px-4 py-2.5 text-white text-sm font-medium
            transform transition duration-300 hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed">

                <img className="h-6" src="/google-icon-logo.svg"/>
                Continue with google</button> */}
            
                <button
  onClick={loginWithGoogle}
  disabled={loading}
  className="flex gap-3 justify-center items-center w-full border-2 rounded-xl mt-4 px-4 py-2.5 text-white text-sm font-medium
  transform transition duration-300 hover:scale-105
  disabled:opacity-50 disabled:cursor-not-allowed"
>
  <img className="h-6" src="/google-icon-logo.svg"/>

  {loading ? "Signing in..." : "Continue with Google"}
</button>

            <div className="flex items-center w-full my-6">

                <div className="flex-1 border-t border-gray-300"></div>

                <span className="px-4 text-gray-300 text-sm font-medium">OR</span>

                <div className="flex-1 border-t border-gray-300"></div>

            </div>



            <form onSubmit={handleLogin} className="mt-6 space-y-6">

                {/* Email Field */}

                <div>

                    <input

                        type="email"

                        value={email}

                        onChange={(e) => setEmail(e.target.value)}

                        required

                        placeholder="email"

                        className="mt-2 block w-full rounded-xl border-0 ring-1 ring-inset ring-dark-border

!bg-white px-3 py-2 !caret-white

!outline-none !focus:outline-none focus:ring-2 !focus:ring-white !placeholder:text-dark-text/60"

                    />

                    {/* ❌ Show error if invalid email */}

                    {email.length > 0 && !isValidEmail(email) && (

                        <p className="mt-1 text-sm text-red-500 font-medium">

                            Please enter a valid email address.

                        </p>

                    )}

                </div>

                {/* Password Field */}

                <div>

                    <input

                        type="password"

                        value={password}

                        onChange={(e) => setPassword(e.target.value)}

                        required

                        placeholder="password"

                        className="mt-2 block w-full rounded-xl border-0 ring-1 ring-inset ring-dark-border

!bg-white px-3 py-2 !caret-white

!outline-none !focus:outline-none focus:ring-2 !focus:ring-white"

                    />

                    {password.length > 0 && password.length < 8 && (

                        <p className="mt-1 text-sm text-red-500 font-medium">

                            Minimum 8 characters required.

                        </p>

                    )}

                </div>

                {/* Forgot Password */}

                <div className="flex justify-end">

                    <a

                        href="/auth/forgot-password"

                        className="text-white underline font-medium text-[18px]"

                    >

                        Forgot password?

                    </a>

                </div>

                {/* Sign In Button */}

                <button

                    type="submit"

                    disabled={!canSubmit || loading}

                    className="w-full rounded-xl bg-indigo-500 px-4 py-2.5 text-white text-sm font-medium

hover:bg-indigo-600 disabled:opacity-50 disabled:cursor-not-allowed"

                >

                    {loading ? "Signing in..." : "Sign in"}

                </button>

            </form>

            {/* Error from backend */}

            {error && (

                <p className="mt-3 text-sm text-red-600 font-medium text-center">

                    {error}

                </p>

            )}

            {/* Sign Up Link */}

            <div className="mt-2 text-sm text-white text-center sm:text-left leading-6">

                Don’t have an account?{" "}

                <a href="/auth/signup" className="underline font-medium">

                    Sign up

                </a>

            </div>

        </>

    );

}